import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const col1 = categories.slice(0, 5);
  const col2 = categories.slice(5, 10);
  const col3 = categories.slice(10, 14);

  return (
    <footer className="bg-foreground-900 text-white">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-1/3">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="text-xl font-heading font-bold tracking-tight">
                Mulebuy<span className="text-accent-400">Spreadsheets</span>
              </span>
            </Link>
            <p className="mt-4 text-sm text-foreground-300 leading-relaxed max-w-sm">
              Your trusted hub for verified mulebuy spreadsheet resources, agent comparisons, and sourcing guides. Updated regularly with the latest data.
            </p>

            <form
              data-readdy-form=""
              action="https://readdy.ai/api/form/d8sms4rf81iibef4bphg"
              method="POST"
              id="newsletter-footer"
              className="mt-6 flex gap-2"
            >
              <input
                type="email"
                name="email"
                placeholder="Your email for updates"
                required
                className="flex-1 px-4 py-2.5 rounded-full bg-foreground-800 border border-foreground-700 text-white placeholder:text-foreground-400 text-sm focus:outline-none focus:border-accent-400 transition-colors"
              />
              <button
                type="submit"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500 text-white hover:bg-accent-400 transition-colors cursor-pointer flex-shrink-0"
              >
                <i className="ri-send-plane-fill text-sm"></i>
              </button>
            </form>
          </div>

          <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Shop Categories</h4>
              <ul className="space-y-2.5">
                {col1.map((cat) => (
                  <li key={cat.seq}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">More Categories</h4>
              <ul className="space-y-2.5">
                {col2.map((cat) => (
                  <li key={cat.seq}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Resources</h4>
              <ul className="space-y-2.5">
                {col3.map((cat) => (
                  <li key={cat.seq}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
                <li>
                  <Link to="/article/mulebuy-spreadsheet-guide" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer">
                    Shopping Guide
                  </Link>
                </li>
                <li>
                  <Link to="/article/mulebuy-spreadsheet-list-2026" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer">
                    Spreadsheet Lists
                  </Link>
                </li>
                <li>
                  <a
                    href={mainSiteUrl}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    Main Platform
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 MulebuySpreadsheets.lol — All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-8 h-8 flex items-center justify-center rounded-md border border-foreground-700 text-foreground-400 hover:text-accent-400 hover:border-accent-400 transition-colors cursor-pointer"
            >
              <i className="ri-global-line text-sm"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-8 h-8 flex items-center justify-center rounded-md border border-foreground-700 text-foreground-400 hover:text-accent-400 hover:border-accent-400 transition-colors cursor-pointer"
            >
              <i className="ri-twitter-x-line text-sm"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-8 h-8 flex items-center justify-center rounded-md border border-foreground-700 text-foreground-400 hover:text-accent-400 hover:border-accent-400 transition-colors cursor-pointer"
            >
              <i className="ri-instagram-line text-sm"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-8 h-8 flex items-center justify-center rounded-md border border-foreground-700 text-foreground-400 hover:text-accent-400 hover:border-accent-400 transition-colors cursor-pointer"
            >
              <i className="ri-discord-line text-sm"></i>
            </a>
          </div>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="text-xs text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
}